import { configureStore } from '@reduxjs/toolkit';
// AlterCPA removed for Greek-CC
// import altercpaReducer from './slices/altercpaSlice';
// BEX Address removed for Greek-CC (Greece uses ACS only)
// import bexAddressReducer from './slices/bexAddressSlice';

export const store = configureStore({
    reducer: {
        // altercpa: altercpaReducer, // Removed for Greek-CC
        // bexAddress: bexAddressReducer, // Removed for Greek-CC
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
